export enum InputTextSize {
  RG = 'rg',
  MD = 'md',
}

export enum InputTextFailedType {
  None = 'none',
  Error = 'error',
  Warning = 'warning',
}
